<template>
<div>
  <h4>Użytkownicy ({{ users.length }})</h4>
  
  <div class="row" style="margin-bottom: 20px;">
    <div class="col-md-3">
      <input type="text" v-model="search" placeholder="Wyszukaj email..." class="form-control" autofocus>
    </div>
    <div class="col-md-2">
      <select v-model="packet" class="form-control">
        <option value="">-- pakiet --</option>
        <option value="free">Free</option>
        <option value="premium">Premium</option>
        <option value="pro">Premium + SMS</option>
      </select>
    </div>
    <div class="col-md-2">
      <select v-model="type" class="form-control">
        <option value="">-- typ konta --</option>
        <option value="buyer">Kupujący</option>
        <option value="seller">Sprzedający</option>
      </select>
    </div>
  </div>
  
  <table class="table table-striped table-hover table-bordered">
    <thead>
    <tr>
      <th>Email</th>
      <th>Telefon</th>
      <th>Dane do faktury</th>
      <th>Utworzenie konta</th>
      <th>Aktywowany</th>
      <th>Pakiet</th>
      <th>Okres próbny</th>
      <th>Wybrane powiadomienia</th>
      <th>Zakończenie pakietu</th>
      <th>Typ konta</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="user in users">
      <td>{{ user.email }}</td>
      <td>{{ user.phone }}</td>
      <td>
        <address>
          {{ user.address.name }} <br>
          {{ user.address.taxId }} <br>
          {{ user.address.streetAndNumber }} <br>
          {{ user.address.postalCode }} <br>
          {{ user.address.city }}
        </address>
      </td>
      <td>{{ user.createdAt|date }}</td>
      <td>
        <boolean-state :state="user.enabled"></boolean-state>
        <br>
        <br>
        <button class="btn btn-primary btn-sm"
                v-show="!user.enabled && !user.sending"
                @click.prevent="resendActivation(user)"
                title="Wyślij link aktywacyjny ponownie"
        >
          Ponów
        </button>
        <span v-show="user.sending">wysyłam...</span>
      </td>
      <td>
        <template v-if="user.access">
          {{ user.access.name|access }}
        </template>
        <template v-else>Brak</template>
      </td>
      <td>
        <template v-if="user.access">
          <boolean-state :state="user.access.isTrial"></boolean-state>
        </template>
        <template v-else>Brak</template>
      </td>
      <td>
        <boolean-state :state="nullToBool(user.notificationSettings)"></boolean-state>
      </td>
      <td>
        <template v-if="user.access">
        {{ user.access.endAt|date }}
        </template>
        <template v-else>Brak</template>
      </td>
      <td>
        {{ user.type|type }}
      </td>
      <td>
        <router-link :to="getRouteToChangePackage(user)">Zmień pakiet</router-link>
      </td>
    </tr>
    </tbody>
  </table>
</div>
</template>
<script>
import Api from './../api'
import BooleanState from './BooleanState.vue'
import debounce from 'tiny-debounce'

export default {
  data () {
    return {
      search: '',
      packet: '',
      type: '',
      users: []
    }
  },
  components: {
    BooleanState
  },
  methods: {
    resendActivation (user) {
      user.sending = true
      Api.user.resendActivation(user.id).then(() => { user.sending = false })
    },
    nullToBool (value) {
      if (!value) {
        return false
      }
      return true
    },
    fetchData (search, packet, type) {
      Api.user.getList(search, packet, type).then(this.onGetListSuccess)
    },
    onGetListSuccess ({body}) {
      this.users = body
    },
    getRouteToChangePackage (user) {
      return {
        name: 'ChangePackage',
        params: {
          id: user.id
        }
      }
    },
    debounceSearch: debounce(function () {
      this.fetchData(this.search, this.packet, this.type)
    }, 500)
  },
  watch: {
    '$route': 'fetchData',
    'search': 'debounceSearch',
    'packet': 'debounceSearch',
    'type': 'debounceSearch'
  },
  created () {
    this.fetchData()
  }
}
</script>



// WEBPACK FOOTER //
// Users.vue?00da6824